export const request = (opts) => {
  return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open(opts.method, opts.url);

      xhr.responseType = opts.responseType || 'json';
      xhr.timeout = opts.timeout || 0;

      xhr.onload = function () {
          if (this.status >= 200 && this.status < 300) {
              resolve(xhr.response);
          } else {
              reject({
                  status: this.status,
                  statusText: xhr.statusText,
              });
          }
      };

      xhr.onerror = function () {
          reject({
              status: this.status,
              statusText: xhr.statusText,
          });
      };

      let body = opts.body;
      if (body && typeof body === 'object') {
        body = JSON.stringify(body);
      }

      if (opts.headers) {
          Object.keys(opts.headers).forEach((key) => {
              xhr.setRequestHeader(key, opts.headers[key]);
          });
      }

      xhr.send(body);
  });
};